export const isFutureReleaseDate = (releaseDate) => {
  const relDate = new Date(releaseDate);
  const today = new Date();
  const yesterday = new Date(today);

  yesterday.setDate(yesterday.getDate() - 1);

  // Release date was yesterday, is today or in the future, then TRUE.
  return yesterday <= relDate;
};
